import React from "react"

import Layout from '../components/layout'
import SEO from "../components/seo"
import FullBackground from '../components/fullbackground'
import LogoImage from '../components/logoimage'
import MainContent from '../components/maincontent'
import Footer from '../components/footer'

function IndexPage() {
  return (
    <Layout>
      <SEO title=""/>
      <FullBackground>
        <div className="logo">
          <LogoImage />
        </div>
        <MainContent />
        <Footer />
      </FullBackground>
    </Layout>
  )
}

export default IndexPage
